module.exports = __webpack_public_path__ + "img/36.689c208e.png";